<template>
  <div class="ui modal" ref="modal">
    <div class="header">{{ title }}</div>
    <div class="scrolling content">
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="six wide field">
                  <label for="user-search-description">Nome ou Documento</label>
                  <input
                    type="text"
                    name="user-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="users"
              :show-actions="false"
              @selected="item => select(item)"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
import Grid from '@/components/grid';

export default {
  components: { Grid },
  props: {
    title: {
      type: String,
      default: 'Selecionar'
    },
    rule: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchForm: {
        description: null
      },
      gridColumns: [
        { description: 'Cod.', field: 'id' },
        { description: 'Nome', kind: 'select', field: 'name' },
        { description: 'CPF / CNPJ', field: 'doc' }
      ]
    };
  },

  methods: {
    open() {
      window.$(this.$refs.modal).modal('show');
    },

    hide() {
      window.$(this.$refs.modal).modal('hide');
    },

    select(item) {
      this.$emit('selected', item);
      this.hide();
    },

    search(page = 1) {
      const query = {
        q: {
          name_or_cpf_or_rg_or_cnpj_or_ie_cont: this.searchForm.description,
          id_eq: this.searchForm.cod,
          s: ['name asc']
        },
        page: page
      };

      if (this.rule.length > 0) {
        query.q.rule_in = this.rule;
      }

      this.$refs.grid.toggleLoading();
      Api.users
        .search(query)
        .then(async response => {
          response.data.users.forEach(user => {
            user.doc = user.cpf || user.cnpj;
          });

          this.$refs.grid.setItems(response.data.users);
          this.$refs.grid.setPaginate(response.data.pagination);
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
